import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from '@/store';
import { isAllModesPath } from '@/lib/interactionExperience';
import { InteractionMode, updateInteractionMode } from '@/store/slices/room';
import styles from './index.module.less';

function ModeSwitch(props: { className?: string; compact?: boolean; ghost?: boolean }) {
  const { className = '', compact = false, ghost = false } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const interactionMode = useSelector((state: RootState) => state.room.interactionMode);
  const allowAllModes = isAllModesPath(location.pathname);

  if (!allowAllModes) return null;

  const items: { mode: InteractionMode; label: string }[] = [
    { mode: 'smart_assistant', label: '普通模式' },
    { mode: 'desktop_companion', label: '桌宠模式' },
    { mode: 'immersive', label: '沉浸模式' },
    // 互动课堂已拆分到独立项目(Voxie-Classroom)并从本项目中移除。
  ];

  return (
    <div
      className={`${styles.switcher} ${compact ? styles.compact : ''} ${
        ghost ? styles.ghost : ''
      } ${className}`.trim()}
    >
      {items.map((item) => (
        <button
          key={item.mode}
          type="button"
          className={`${styles.item} ${interactionMode === item.mode ? styles.active : ''}`.trim()}
          aria-pressed={interactionMode === item.mode}
          onClick={() => {
            if (interactionMode === item.mode) return;
            dispatch(updateInteractionMode({ interactionMode: item.mode }));
          }}
        >
          <span className={styles.label}>{item.label}</span>
        </button>
      ))}
    </div>
  );
}

export default memo(ModeSwitch);
